import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EmbeddedVideoComponent } from '@molecules/embedded-video/embedded-video.component';
import { BaseButtonDirective } from '@shared/base-button.directive';
import { BaseIconDirective } from '@shared/base-icon.directive';
import { BaseLinkDirective } from '@shared/base-link.directive';

import { AutoRenewalModalComponent } from './auto-renewal-modal/auto-renewal-modal.component';
import { BannerComponent } from './banner/banner.component';
import { BaseErrorModalComponent } from './base-error-modal/base-error-modal.component';
import { CoveragesModalComponent } from './coverages-modal/coverages-modal.component';
import { CustomInputDirective } from './custom-input.directive';
import { ElectronicDisclosureModalComponent } from './electronic-disclosure-modal/electronic-disclosure-modal.component';
import { EmbracePolicyModalComponent } from './embrace-policy-modal/embrace-policy-modal.component';
import { EpiControlDirective } from './epi-control.directive';
import { EpiRadioControlDirective } from './epi-radio-control.directive';
import { ExperimentLayerDirective } from './experiment-layer-directive';
import { FeatureFlagDirective } from './feature-flag-directive';
import { HideProdDirective } from './hide-prod.directive';
import { InputMaskDirective } from './input-mask.directive';
import { MaAutoRenewalNoticeModalComponent } from './ma-auto-renewal-notice-modal/ma-auto-renewal-notice-modal.component';
import { DialogCloseDirective } from './modal-dialog/dialog-close.directive';
import { RemovePetModalComponent } from './remove-pet-modal/remove-pet-modal.component';
import { SharedSelectComponent } from './shared-select/shared-select.component';
import { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
import { StateFraudModalComponent } from './state-fraud-modal/state-fraud-modal.component';
import { TermsOfServiceModalComponent } from './terms-of-service-modal/terms-of-service-modal.component';
import { TooltipComponent } from './tooltip/tooltip.component';
@NgModule({
	declarations: [
		CustomInputDirective,
		BaseButtonDirective,
		BaseLinkDirective,
		BaseIconDirective,
		InputMaskDirective,
		EpiControlDirective,
		EpiRadioControlDirective,
		SlideToggleComponent,
		RemovePetModalComponent,
		TermsOfServiceModalComponent,
		ElectronicDisclosureModalComponent,
		CoveragesModalComponent,
		BaseErrorModalComponent,
		HideProdDirective,
		EmbracePolicyModalComponent,
		StateFraudModalComponent,
		BannerComponent,
		AutoRenewalModalComponent,
		MaAutoRenewalNoticeModalComponent,
		TooltipComponent,
		ExperimentLayerDirective,
		FeatureFlagDirective,
		SharedSelectComponent,
		DialogCloseDirective,
		EmbeddedVideoComponent
	],
	imports: [
		CommonModule,
		CdkTableModule,
		ReactiveFormsModule,
	],
	exports: [
		CustomInputDirective,
		BaseButtonDirective,
		BaseLinkDirective,
		BaseIconDirective,
		InputMaskDirective,
		EpiControlDirective,
		EpiRadioControlDirective,
		SlideToggleComponent,
		HideProdDirective,
		BannerComponent,
		AutoRenewalModalComponent,
		TooltipComponent,
		ExperimentLayerDirective,
		SharedSelectComponent,
		DialogCloseDirective,
		FeatureFlagDirective,
		EmbeddedVideoComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
